
<div>
  <kendo-datepicker #editeurDate
                    [format]="'dd/MM/yyyy'"
                    [formatPlaceholder]="{year: 'aaaa', month: 'mm', day: 'jj'}"
                    [placeholder]="''"
                    calendarType="classic"
                    (close)="TraiterFermeturePopUp()"
                    [(value)]="valeur">
  </kendo-datepicker>
</div>
<kendo-grid-filter-cell-operators class="val-filter-cell-operateur"
                                  [column]="column"
                                  [(value)]="operateur"
                                  [showOperators]="true"
                                  [operators]="[{text: 'Egal', value: 'eq'}, {text: 'Inférieur ou égal', value: 'lte'}, {text: 'Supérieur ou égal', value: 'gte'}]"
                                  (valueChange)="ChangerOperateur()">
</kendo-grid-filter-cell-operators>
<button kendoButton
        [svgIcon]="boutonEffacerIcone"
        class="val-bouton-effacer-filtre"
        [ngClass]="{'val-invisible': !boutonEffacerVisible}"
        (click)="Effacer()">
</button>

